import {
  ArrowchevronDownIcon,
  ArrowchevronUpIcon,
  CopyIcon,
  SearchIcon,
} from '@bfe/moly-icons';
import { ColumnDef } from '@tanstack/react-table';
import { useFm, useParams, useToast, useWallet } from '@web3/base-hooks';
import {
  appPath,
  invoke,
  removeTrailingZeros,
  shortenAddress,
  WalletChainTypes,
} from '@web3/base-utils';
import { Address } from '@ton/core';
import { PublicKey } from '@solana/web3.js';
import cls from 'classnames';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
// import { SimpleLine } from '@bfe/moly-chart';
import allChainsIcon from '@/assets/svg/allchain.svg';
import btcIcon from '@/assets/svg/btc.svg';
import selectIcon from '@/assets/svg/select.svg';
import { utils } from 'ethers';
import emptyIcon from '@/assets/svg/empty.svg';
import addIcon from '@/assets/svg/icon_plus.svg';
import settingIcon from '@/assets/svg/icon_setting.svg';
import LazyImage from '@/components/LazyImage';
import {
  getChartData,
  getDefiData,
  // getDexProSupportedChains,
  getInscriptionData,
  getNftData,
  getNftList,
  getOpenNftList,
  queryBalanceList,
} from '@/services/wallet';
import useObserveStore from '@/store/observe';
import {
  SwapScene,
  WalletChainTokenBalance,
  WalletType,
  WalletTypeString,
} from '@/types/wallet';
import {
  Button,
  Checkbox,
  Empty,
  Input,
  Modal,
  Pagination,
  Spin,
  Table,
  Tabs,
  Textarea,
} from '@bfe/moly';
import BigNumber from 'bignumber.js';
import copy from 'copy-to-clipboard';
import styles from './index.module.scss';

import { NFT_SUPPORT_CHAIN, NFT_VIDEO_TYPES } from '@/utils';
import { ImageWithDefault } from '@web3/base-components';
import {
  thirdPartyWallet,
  useChainList,
  useCurrentWallet,
  Web3CopyCloudWalletModal,
  Web3DepositModal,
} from '@web3fe/infra';

const Select = dynamic(() => import('@bfe/moly/dist/es/Select/index'), {
  ssr: false,
});

const SimpleLine = dynamic(
  () => import('@bfe/moly-chart/dist/es/components/SimpleLine'),
  {
    ssr: false,
  }
);

export const Content = () => {
  const fm = useFm();
  const wallet = useCurrentWallet();
  const { locale } = useParams();

  const { walletType, walletId, mixedChainMap, chainList, thirdConnected } =
    useWallet();
  const { getChain } = useChainList();
  const router = useRouter();
  const stepMap = {
    week: 60 * 1000 * 60 * 24 * 7,
    month: 60 * 1000 * 60 * 24 * 30,
  };

  const [searchText, setSearchText] = useState('');
  const [showAddWallet, setShowAddWallet] = useState(false);
  const [showWalletDropDown, setShowWalletDropDown] = useState(false);
  const [checked, setChecked] = useState(false);
  const [page, setPage] = useState(1);
  const [nftCursor, setNftCursor] = useState('');
  const [formWalletName, setFormWalletName] = useState('');
  const [formWalletChain, setFormWalletChain] = useState('ETH');
  const [formWalletAddress, setFormWalletAddress] = useState('');
  const [chartData, setChartData] = useState([]);
  const [defiData, setDefiData] = useState([]);
  const [inscriptionData, setInscriptionData] = useState([]);
  const [nftData, setNftData] = useState([]);
  const [chartStep, setChartStep] = useState(stepMap.week);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [showDepostiModal, setShowDepositModal] = useState(false);
  const [depositToken, setDepositToken] = useState('');
  const [depositChain, setDepositChain] = useState('');
  const [observeInfo, setObserveInfo] = useState({
    address: '',
    name: '',
    chainCode: '',
  });
  const [observeDataList, setObserveDataList] = useState({
    dataList: [],
    totalAmountUsd: '-',
  } as { dataList: WalletChainTokenBalance[]; totalAmountUsd: string });
  // const [dexProSupportChain, setDexProSupportChain] = useState({});
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   getDexProSupportedChains().then((data) => {
  //     const chains = {};
  //     data.result
  //       ?.filter((chain) =>
  //         chain?.supportSceneConfig?.some((it) => it.scene === SwapScene.DexPro)
  //       )
  //       .forEach((item) => {
  //         chains[item.chainCode] = true;
  //       });
  //     setDexProSupportChain(chains);
  //   });
  // }, []);

  const {
    addWallet,
    isExist,
    isMax,
    walletList: ObserveWalletLest,
    hideRiskNft,
    setHideRisk,
  } = useObserveStore();

  const pageSize = 10;
  const { toastSuccess, toastFail } = useToast();

  const onCheckedChange = (e: Event, checked: boolean) => {
    setPage(1);
    setChecked(checked);
  };
  const onInputChange = (e: Event) => {
    setSearchText(e.currentTarget.value);
  };

  const onHideRiskChange = (e: Event, checked: boolean) => {
    setNftCursor('');
    setNftData([]);
    setHideRisk(checked);
    fetchNftData();
  };

  const thirdPartyMainAddress =
    thirdPartyWallet.wallets?.EVM?.address ??
    Object.values(thirdPartyWallet.wallets ?? {})[0]?.address ??
    '';

  const changeHandler = (val) => {
    router.replace(
      {
        pathname: `/${locale}${appPath}`,
        query: { ...router.query, chainCode: val },
      },
      undefined,
      { shallow: true }
    );
  };
  const tokenDefaultColumns = [
    {
      accessorKey: 'assets',
      header: () => fm('assets_th1'),
      cell: ({ row }) => {
        const chainLogo = mixedChainMap[row.original.chainId]?.iconNightUrl;
        const item = row.original;
        const chain = getChain(item.chainId);

        return (
          <div className="flex flex-row items-center">
            <div className="relative w-32px h-32px mr-16px">
              <ImageWithDefault
                src={row.original.iconNightUrl}
                className="w-32px h-32px rounded-32px"
                alt=""
              />
              <ImageWithDefault
                src={chainLogo}
                className="w-12px h-12px absolute bottom-0 right-0 rounded-12px"
                alt=""
              />
            </div>
            <div className="text-14px leading-22px">
              {invoke(() => {
                if (chain.chainType === WalletChainTypes.BTC) {
                  return (
                    <div className="flex items-center">
                      <span>{item.symbol || item.name}</span>
                      <span className="text-[12px] text-bds-gray-t2 ml-4px">
                        ({chain.chainName})
                      </span>
                    </div>
                  );
                }
                return item.symbol || item.name;
              })}
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: 'price',
      header: () => fm('assets_th2'),
      cell: ({ row }) =>
        `$ ${removeTrailingZeros(BigNumber(row.original.price).toFormat(8))}`,
    },
    {
      accessorKey: 'balance',
      header: () => fm('assets_th3'),
      cell: ({ row }) =>
        `${removeTrailingZeros(BigNumber(row.original.balance).toFormat(8))}`,
    },
    {
      accessorKey: 'value',
      header: () => fm('assets_th4'),
      cell: ({ row }) =>
        `$ ${removeTrailingZeros(BigNumber(row.original.balanceUsd).toFormat(2))}`,
    },
  ];
  const columns: ColumnDef<any>[] = useMemo(() => {
    if (observeInfo.address) {
      return tokenDefaultColumns;
    } else {
      return [
        ...tokenDefaultColumns,
        {
          accessorKey: 'opt',
          header: () => (
            <div style={{ textAlign: 'right' }}>{fm('action')}</div>
          ),
          cell: ({ row }) => {
            return (
              <div style={{ textAlign: 'right' }}>
                {/* {dexProSupportChain[row.original.chainCode] && (
                  <Button
                    onClick={() => {
                      router.push({
                        pathname: `${locale}/web3/dex/${row.original.chainCode?.toLowerCase()}/`,
                        query: { utm_content: 'assets' },
                      });
                    }}
                    variant="secondary"
                    size="xx-small"
                    className="mr-24px"
                  >
                    {fm('apex_swap')}
                  </Button>
                )} */}
                <Button
                  onClick={() => {
                    setDepositToken(row.original.symbol || row.original.name);
                    setDepositChain(row.original.chainCode);
                    setShowDepositModal(true);
                  }}
                  variant="primary"
                  size="xx-small"
                >
                  {fm('deposit')}
                </Button>
              </div>
            );
          },
        },
      ];
    }
  }, [observeInfo.address, wallet.walletIsReady]);

  const walletTotalBalance = useMemo(() => {
    if (observeInfo.address) {
      return observeDataList.totalAmountUsd;
    } else {
      return wallet.totalBalance;
    }
  }, [
    observeInfo.address,
    wallet.totalBalance,
    observeDataList.totalAmountUsd,
  ]);
  const cellDataFormatter = (value: number | string) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    if (BigNumber(value).abs().lt(0.01) && BigNumber(value).abs().gt(0)) {
      return `≈$ ${BigNumber(value).lt(0) ? '-' : ''}0.01`;
    }
    return `$ ${BigNumber(value).toFixed(2)}`;
  };

  const defiDefaultColumns = [
    {
      accessorKey: 'pool',
      header: () => fm('liquidity_pool'),
      cell: ({ row }) => (
        <div className="flex flex-row">
          {row.original.baseStakeCoins.map((item) => (
            <img
              key={item.coinDetailJson.iconNightUrl}
              className="w-30px ml-[-10px] h-30px rounded-15px"
              src={item.coinDetailJson.iconNightUrl}
            ></img>
          ))}
        </div>
      ),
    },
    {
      accessorKey: 'rate',
      header: () => fm('staking_profit_and_loss'),
      cell: ({ row }) => (
        <div className="text-green">
          {row.original.yieldPkg ? `${row.original.yieldPkg.rate}%` : '-'}
        </div>
      ),
    },
    {
      accessorKey: 'depositInUsd',
      header: () => fm('staking_principal'),
      cell: ({ row }) =>
        `${row.original.depositInUsd ? cellDataFormatter(row.original.depositInUsd) : '-'}`,
    },
    {
      accessorKey: 'lpTokens',
      header: () => fm('investment_share'),
      cell: ({ row }) => `$ ${BigNumber(row.original.lpTokens).toFixed(8)}`,
    },
  ];
  const defiColumns: ColumnDef<any>[] = useMemo(() => {
    if (observeInfo.address) {
      return defiDefaultColumns;
    } else {
      return [
        ...defiDefaultColumns,
        {
          accessorKey: 'accumulateReward',
          header: () => fm('accumulated_revenue'),
          cell: ({ row }) =>
            `${row.original.yieldPkg ? cellDataFormatter(row.original.yieldPkg?.yield) : '-'}`,
        },
      ];
    }
  }, [observeInfo.address]);

  const getColor = (coin: string) => {
    const colors = ['#9747FF', '#28C6B6', '#FF9C2E', '#5BD45F'];
    let coinNameCount = 0;
    for (let i = 0; i < coin.length; i += 1) {
      coinNameCount += coin.charCodeAt(i);
    }
    return colors[coinNameCount % colors.length];
  };

  function formatDateTime(ts: number) {
    const dd = new Date(ts);
    console.log('dd', dd);
    return `${dd.getFullYear()}-${dd.getMonth() + 1}-${dd.getDate()}`;
  }

  const handleToDetail = (data) => {
    router.push({
      pathname: `/${locale}/web3/inscription/project-detail`,
      query: { tick: data.tick },
    });
  };

  const handleToTransfer = (data) => {
    router.push({
      pathname: `/${locale}/web3/inscription/project-detail`,
      query: { tick: data.tick, transfer: 1 },
    });
  };
  // 铭文列
  const inscriptionColummsDefault = [
    {
      accessorKey: 'tick',
      header: () => fm('projectName'),
      cell: ({ row }) => {
        return (
          <div onClick={() => handleToDetail(row)} className="cursor-pointer">
            <div
              className="flex-row flex items-center"
              style={{ minHeight: '32px' }}
            >
              <div
                className="uppercase"
                style={{
                  background: getColor(row.original.tick),
                  marginRight: '6px',
                  lineHeight: '40px',
                  textAlign: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '4px',
                }}
              >
                {row.original.tick.substr(0, 2)}
              </div>
              <span className="m-l8px uppercase">{row.original.tick}</span>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: 'network',
      header: () => fm('network'),
      cell: ({ row }) => (
        <div className="flex items-center">
          {btcIcon()}
          <span className="pl-4px">BRC-20</span>
        </div>
      ),
    },
    {
      accessorKey: 'price',
      header: () => fm('assets_th2'),
      cell: ({ row }) => {
        if (!row.original.price || String(row.original.price) === '-1')
          return '--';
        const items = row.original.price.split('.');
        if (!items[1] || items[1].length < 2)
          return `$${BigNumber(row.original.price).toFixed(2)}`;
        return `${items[0]}.${items[1].slice(0, 8)}`;
      },
    },
    {
      accessorKey: 'amount',
      header: () => fm('assets_th3'),
      cell: ({ row }) => `$ ${row.original.overallBalance}`,
    },
  ];
  const inscriptionColumms: ColumnDef<any>[] = useMemo(() => {
    if (observeInfo.address) {
      return inscriptionColummsDefault;
    } else {
      return [
        ...inscriptionColummsDefault,
        {
          accessorKey: 'opt',
          header: () => (
            <div style={{ textAlign: 'right' }}>{fm('action')}</div>
          ),
          cell: ({ row }) => {
            return (
              <div style={{ textAlign: 'right' }}>
                <Button
                  variant="secondary"
                  onClick={() => handleToDetail(row.original)}
                  size="xx-small"
                  className="mr-24px"
                >
                  {fm('trade2')}
                </Button>
                <Button
                  variant="primary"
                  onClick={() => handleToTransfer(row.original)}
                  size="xx-small"
                >
                  {fm('transfer2')}
                </Button>
              </div>
            );
          },
        },
      ];
    }
  }, [observeInfo.address]);
  const smallBalance = 1;

  // 钱包基础信息
  const walletInfo = useMemo(() => {
    if (observeInfo.address) {
      return {
        label: `${fm('wallet_observe')} ${observeInfo.name}`,
        icon: '',
      };
    } else if (walletType === WalletType.THIRD_PARTY) {
      return {
        label: thirdPartyWallet.activeWalletHub.name,
        icon: (
          <img
            src={thirdPartyWallet.activeWalletHub?.icon?.replace(/\n/g, '')}
          ></img>
        ),
      };
    } else if (
      walletType === WalletType.MNEMONIC_PHRASE ||
      walletType === WalletType.PRIVATE_KEY ||
      walletType === WalletType.CLOUD
    ) {
      return {
        label: fm('wallet_web3'),
        icon: '',
      };
    } else {
      return {
        label: '',
        icon: '',
      };
    }
  }, [walletType, observeInfo.address]);

  // 当前链
  const currentChain = useMemo(() => {
    if (observeInfo.address) {
      return observeInfo.chainCode;
    }
    return router.query.chainCode || 'ALL';
  }, [router.query.chainCode, observeInfo.address]);

  // 当前地址 (兼容观察者)
  const currentAddress = useMemo(() => {
    if (observeInfo.address) {
      return observeInfo.address;
    } else if (walletType === WalletType.CLOUD) {
      return wallet.getAddress(currentChain) || wallet.getAddress('ETH');
    } else {
      return thirdPartyMainAddress;
    }
  }, [observeInfo.address, currentChain, walletType, wallet.walletIsReady]);

  // 代币列表
  const tokenList = useMemo(() => {
    let list = [];
    if (observeInfo.address) {
      console.log('observeDataList?.dataList', observeDataList?.dataList);
      list = observeDataList?.dataList || [];
    } else {
      if (currentChain === 'ALL') {
        list = wallet.chainBalanceList
          .map((item) => item.tokenAsset)
          .flat()
          .sort((tokenA, tokenB) => tokenB.balanceUsd - tokenA.balanceUsd);
      } else {
        const info = wallet.chainBalanceList.find(
          (item) => item.chainCode === currentChain
        );
        if (info) {
          list = info.tokenAsset.sort(
            (tokenA, tokenB) => tokenB.balanceUsd - tokenA.balanceUsd
          );
        }
      }
    }

    if (checked) {
      list = list.filter((item) => {
        return +item.balanceUsd > smallBalance;
      });
    }
    if (searchText) {
      list = list.filter((item) => {
        return (
          (item.symbol || item.name || '')
            .toLowerCase()
            .indexOf(searchText.toLowerCase()) !== -1 ||
          (item.contract || '').toLowerCase() === searchText.toLowerCase()
        );
      });
    }
    return list;
  }, [
    wallet.chainBalanceList,
    currentChain,
    checked,
    searchText,
    observeDataList?.dataList,
  ]);

  // 分页数据
  const pageTokenList = useMemo(() => {
    const list = tokenList.slice((page - 1) * pageSize, page * pageSize);
    return list;
  }, [tokenList, page]);

  // 链列表
  const chainListData = useMemo(() => {
    const data = observeInfo.address
      ? (observeDataList?.dataList?.slice(0, 1) || []).map((listItem) => {
          const item = getChain(listItem.chainId);
          if (!item) return;
          return {
            icon: (
              <img
                className="w-14px h-14px rounded-7px"
                src={item.iconNightUrl}
              ></img>
            ),
            label: item.chainCode === 'BTC' ? 'BitCoin' : item.chainName,
            value: item.chainCode,
            amountUsd: listItem.amountUsd || listItem.balanceUsd,
          };
        })
      : [
          {
            icon: allChainsIcon(),
            label: fm('allchains'),
            value: 'ALL',
          },
          ...wallet.chainBalanceList.map((listItem) => {
            const item = getChain(listItem.chainId);
            if (!item) return;
            return {
              icon: (
                <img
                  className="w-14px h-14px rounded-7px"
                  src={item.iconNightUrl}
                ></img>
              ),
              label: item.chainCode === 'BTC' ? 'BitCoin' : item.chainName,
              value: item.chainCode,
              amountUsd:
                item.chainCode === 'BTC'
                  ? listItem.tokenAsset
                      .map((item) => item.balanceUsd || listItem.amountUsd || 0)
                      .reduce((a, b) => BigNumber(a).plus(b), BigNumber(0))
                      .toFormat(2)
                  : listItem.amountUsd || listItem.balanceUsd,
            };
          }),
        ].filter((item) => !!item);
    return data;
  }, [
    chainList,
    walletType,
    observeDataList?.dataList,
    observeInfo.address,
    wallet.chainBalanceList,
  ]);

  // 渲染nft 卡片
  function renderNftCard(item) {
    return (
      <div
        onClick={() =>
          router.push({
            pathname: `/${locale}${appPath}/nft`,
            query: {
              tokenId: item.tokenId,
              contractAddress: item.contractAddress,
              amount: item.amount,
              // solana传入的价格
              latestTradePrice: item.latestTradePrice ?? '',
              // 币种
              latestTradeSymbol: item.latestTradeSymbol ?? '',
            },
            hash: JSON.stringify(item),
          })
        }
        className={styles['list-item']}
      >
        <LazyImage
          src={
            (item.nftImage ||
              item?.imageUrl ||
              item?.imageUri ||
              item?.contentUri) ??
            ''
          }
          width={250}
          height={250}
          objectFit="cover"
          alt=""
          paddingTop={0}
          isHead={true}
          onErrorReportKey="txexe"
          defaultImageClassName={styles.img}
        />
        {/* <img src={item.contentUri} alt="" /> */}
        <div className="truncate text-18px leading-26px w-240px font-700">
          {item.contractName}
        </div>
        <div
          className="truncate w-240px mt-6px text-14"
          style={{ color: 'rgba(173, 177, 184, 1)' }}
        >
          {item.nftName}
        </div>
        {NFT_VIDEO_TYPES.indexOf(item.contentType) !== -1 && (
          <span className={styles['nft-video']}></span>
        )}
      </div>
    );
  }
  const filteredNftData = useMemo(() => {
    if (!hideRiskNft) {
      return nftData;
    } else {
      return nftData.filter((item) => !item.riskNft);
    }
  }, [nftData]);

  // tab数据
  const tabList = useMemo(() => {
    const base = [
      {
        key: 'token',
        label: fm('tokens_p'),
        children: loading ? (
          <div className="text-center">
            <Spin size="large" />
          </div>
        ) : (
          <>
            {' '}
            <Table
              className={cls(['"mt-24px"', styles.table])}
              columns={columns}
              data={pageTokenList}
            />
            <div className="h-64px flex flex-row items-center justify-end">
              <Pagination
                total={tokenList.length}
                defaultPageSize={pageSize}
                current={page}
                onChange={(page) => setPage(page)}
              />
            </div>
          </>
        ),
      },
      {
        key: 'nft',
        label: fm('nft_p'),
        children: (
          <div className="mt-10">
            {loading ? (
              <div className="text-center" style={{ paddingBottom: '60px' }}>
                <Spin size="large" />
              </div>
            ) : NFT_SUPPORT_CHAIN.indexOf(currentChain) === -1 ? (
              <div
                className="flex flex-col items-center jusify-center"
                style={{ paddingBottom: '60px' }}
              >
                {' '}
                {emptyIcon()}{' '}
                <span className="mt-20px">
                  {fm('nft_chain_suport', { chain: currentChain })}
                </span>
              </div>
            ) : (
              filteredNftData.length === 0 && (
                <Empty
                  style={{ padding: '80px' }}
                  className="mt-40px"
                  size="small"
                  title={fm('nft_list_empty')}
                ></Empty>
              )
            )}
            {NFT_SUPPORT_CHAIN.indexOf(currentChain) !== -1 &&
              nftData &&
              nftData.length > 0 && (
                <div className={styles.list}>
                  {filteredNftData.map((item) => renderNftCard(item))}
                </div>
              )}
            {NFT_SUPPORT_CHAIN.indexOf(currentChain) !== -1 && nftCursor && (
              <div className="flex justify-center mt-30px mb-30px">
                <Button
                  loading={loading}
                  variant="primary"
                  onClick={fetchNftData}
                >
                  {fm('load_more')}
                </Button>
              </div>
            )}
          </div>
        ),
      },
    ];
    if (walletType === WalletType.CLOUD) {
      base.push({
        key: 'defi',
        label: fm('Defi'),
        children: loading ? (
          <div className="text-center">
            <Spin size="large" />
          </div>
        ) : (
          <Table className="mt-24px" columns={defiColumns} data={defiData} />
        ),
      });
    }
    if (currentChain === 'BTC') {
      base.push({
        key: 'inscription',
        label: fm('inscriptions'),
        children: loading ? (
          <div className="text-center">
            <Spin size="large" />
          </div>
        ) : (
          <Table
            className="mt-24px"
            columns={inscriptionColumms}
            data={inscriptionData}
          />
        ),
      });
    }
    return base;
  }, [
    walletType,
    currentChain,
    router.query.tab,
    router.query.chainCode,
    inscriptionData,
    defiData,
    pageTokenList,
    nftData,
    loading,
  ]);

  // 获取图表数据
  async function fetchData() {
    const res = await getChartData({
      chainId: '0',
      beginTime: `${Date.now() - chartStep}`,
      endTime: `${Date.now()}`,
      walletId,
      walletType: WalletTypeString[`WalletType${walletType}`],
    });
    setChartData(
      res?.result?.point?.map((item) => {
        return {
          dateTime: formatDateTime(+item.dateTime),
          value: BigNumber(BigNumber(item.assetAmount).toFixed(2)).toNumber(),
        };
      })
    );
  }

  // 获取defi 数据
  async function fetchDefiData() {
    setLoading(true);
    const res = await getDefiData(currentChain);
    setLoading(false);
    setDefiData(res?.result || []);
  }

  // 获取铭文数据
  async function fetchInscriptionData() {
    setLoading(true);
    const res = await getInscriptionData(wallet.getAddress('BTC'));
    setLoading(false);
    setInscriptionData(res?.result?.detail || []);
  }

  useMemo(() => {
    if (
      wallet.walletIsReady &&
      router.query.chainCode !== 'ALL' &&
      wallet.chainBalanceList.length > 0 &&
      router.query.chainCode
    ) {
      if (
        !wallet.chainBalanceList.find(
          (item) => item.chainCode === router.query.chainCode
        )
      ) {
        router.replace({
          pathname: `/${locale}${appPath}`,
          query: { ...router.query, chainCode: 'ALL' },
        });
      }
    }
  }, [wallet.walletIsReady, wallet.chainBalanceList, router.query.chainCode]);

  // 获取观察者数据
  useMemo(() => {
    if (!observeInfo.address) return;
    setLoading(true);
    const chainId = getChain(observeInfo.chainCode)?.chainId || 1;

    queryBalanceList({
      type: WalletType.FOLLOW_ADDRESS,
      walletId,
      addressChain: [{ chainId: `${chainId}`, address: currentAddress }],
    }).then(({ result }) => {
      setLoading(false);
      setObserveDataList({
        dataList: result.addressDetail ? result.addressDetail[0].tokenInfo : [],
        totalAmountUsd: result.totalAmountUsd,
      });
    });
  }, [observeInfo.address]);

  // 获取nft数据
  async function fetchNftData() {
    if (NFT_SUPPORT_CHAIN.indexOf(currentChain) === -1 || !currentAddress)
      return;
    setLoading(true);
    if (walletType === WalletType.CLOUD) {
      if (currentChain === 'SOL') {
        const { success, result, message } = await getNftData({
          accountAddress: currentAddress,
          cursor: nftCursor,
          limit: 12,
          chainCode: currentChain,
        });
        setLoading(false);
        if (success) {
          setNftCursor(result?.next);
          setNftData([
            ...nftData,
            ...result.content.map((item) => ({
              amount: 1,
              contractAddress: item.tokenAddress,
              contractName: item.collection,
              contractType: null,
              id: item.tokenAddress,
              nftName: item.name,
              tokenId: null,
              contentType: item.contentType,
              contentUri: item.contentUri,
              imageUri: item.imageUri,
              latestTradePrice: item.latestTradePrice,
              latestTradeSymbol: item.latestTradeSymbol,
              network: 'Solana',
            })),
          ]);
        } else {
          toastFail(message);
        }
      } else {
        const { success, result, message } = await getNftList({
          walletAddress: currentAddress,
          chainCode: currentChain,
        });
        setLoading(false);
        if (success) {
          setNftData(result);
        } else {
          toastFail(message);
        }
      }
    } else {
      const { success, result, message } = await getOpenNftList({
        walletAddress: currentAddress,
        chainCode: currentChain,
      });
      setLoading(false);
      if (success) {
        setNftData(result);
      } else {
        toastFail(message);
      }
    }
  }

  // 复制地址
  function copyAll() {
    // // 观察者模式
    // if (observeInfo.address) {
    //   copy(observeInfo.address);
    //   toastSuccess(fm('copy_success'));
    // } else if (walletType === WalletType.CLOUD) {
    //   setShowCopyModal(true);
    // } else {
    //   copy(thirdPartyMainAddress);
    //   toastSuccess(fm('copy_success'));
    // }
    // 观察者模式
    if (observeInfo.address) {
      copy(observeInfo.address);
      toastSuccess(fm('copy_success'));
    } else {
      setShowCopyModal(true);
    }
  }

  // btc 地址校验
  function isValidNativeSegWit(address) {
    return (
      typeof address === 'string' &&
      address.startsWith('bc1') && // 前缀
      (address.length === 42 || address.length === 62) // 长度
    );
  }

  function isValidSuiAddress(address) {
    // Sui 地址通常以 '0x' 开头，后面跟着 40 个十六进制字符
    const suiAddressPattern = /^0x[a-fA-F0-9]{64}$/;
    return suiAddressPattern.test(address);
  }

  function isValidTonAddress(address) {
    try {
      return Address.isAddress(address);
    } catch (e) {
      return false;
    }
  }

  function isValidTronAddress(address) {
    return /^T[a-zA-Z0-9]{33}$/.test(address) || utils.isAddress(address);
  }

  function checkAddress() {
    const info = chainList.find((item) => item.chainCode === formWalletChain);
    if (!info) return true;

    switch (info.chainType) {
      case WalletChainTypes.EVM:
        return utils.isAddress(formWalletAddress);
      case WalletChainTypes.BTC:
        return isValidNativeSegWit(formWalletAddress);
      case WalletChainTypes.STACKS:
        return /SP[0-9A-Za-z]{37,39}/.test(formWalletAddress);
      case WalletChainTypes.SOLANA:
        try {
          new PublicKey(formWalletAddress);
          return true;
        } catch (error) {
          return false;
        }
      case WalletChainTypes.SUI:
        return isValidSuiAddress(formWalletAddress);
      case WalletChainTypes.TON:
        return isValidTonAddress(formWalletAddress);
      case WalletChainTypes.TRON:
        return isValidTronAddress(formWalletAddress);
      default:
        return true;
    }
  }

  // 添加观察钱包
  function addObserveWallet() {
    if (isExist(formWalletName, formWalletAddress))
      return toastFail(fm('walletExist'));
    if (isMax()) return toastFail(fm('walletExceedingMaximum'));

    if (formWalletName?.length > 30) return toastFail(fm('walletNameSoLong'));

    if (!checkAddress()) return toastFail(fm('input_error'));

    const info = {
      address: formWalletAddress,
      chainCode: formWalletChain,
      name: formWalletName,
    };
    addWallet(info);
    setFormWalletName('');
    setFormWalletChain('ETH');
    setShowAddWallet(false);
  }

  // 获取图表数据
  useEffect(() => {
    if (!wallet.walletIsReady) return;
    fetchData();
  }, [chartStep, currentAddress, observeInfo.address, wallet.walletIsReady]);

  // 更新table数据
  useEffect(() => {
    if (!wallet.walletIsReady) return;

    if (router.query.tab === 'defi') {
      fetchDefiData();
    } else if (router.query.tab === 'inscription') {
      fetchInscriptionData();
    } else if (router.query.tab === 'nft') {
      fetchNftData();
    }
  }, [router.query.tab, currentChain, wallet.walletIsReady]);

  return (
    <div className="flex flex-col justify-center items-center">
      <div className={styles.wrap}>
        {/* 钱包左侧基础信息 */}
        <div className={cls('flex flex-row items-center', styles['base-info'])}>
          <div className="flex-1 font-normal text-24px">
            <div className="flex flex-row items-center relative leading-32px">
              <div
                className="flex flex-row items-center"
                onClick={() => setShowWalletDropDown(!showWalletDropDown)}
              >
                <div className={styles['base-info-icon']}></div>
                <div className="ml-8px mr-4px">{walletInfo.label}</div>
                {showWalletDropDown ? (
                  <ArrowchevronUpIcon
                    style={{ width: 20, height: 20 }}
                    className="mr-16px"
                  />
                ) : (
                  <ArrowchevronDownIcon
                    style={{ width: 20, height: 20 }}
                    className="mr-16px"
                  />
                )}
              </div>
              <CopyIcon onClick={copyAll} style={{ width: 20, height: 20 }} />
              {showWalletDropDown && (
                <div
                  className={styles.dropdown}
                  onMouseLeave={() => setShowWalletDropDown(false)}
                >
                  <div
                    className="text-14px h-40px leading-40px"
                    style={{
                      color: 'rgba(173, 177, 184, 1)',
                      padding: '0 24px',
                    }}
                  >
                    {' '}
                    {fm('wallet_mine')}
                  </div>
                  <div>
                    {/* {
                      hasWallet && <div onClick={() => {
                        setObserveInfo({address: '', name: '', chainCode: ''})
                        wallet.switchToBrowser()
                      }} className={styles['dropdown-item']}> {fm('bybitCloudWallet')}</div>
                    } */}
                    {thirdConnected && (
                      <div
                        style={{
                          padding: '0 24px',
                          position: 'relative',
                        }}
                        onClick={() => {
                          setObserveInfo({
                            address: '',
                            name: '',
                            chainCode: '',
                          });
                          wallet.switchToThirdParty();
                        }}
                      >
                        <div
                          className="text-16px leading-24px font-500"
                          style={{ cursor: 'pointer' }}
                        >
                          {fm('wallet_web3')}
                        </div>
                        <div
                          className="text-14px leading-22px"
                          style={{ color: 'rgba(129, 133, 140, 1)' }}
                        >
                          {shortenAddress(currentAddress || '')}
                        </div>
                        {!observeInfo.address && (
                          <div
                            style={{
                              position: 'absolute',
                              right: '16px',
                              marginTop: '-14px',
                              top: '50%',
                            }}
                          >
                            {selectIcon()}
                          </div>
                        )}
                      </div>
                    )}
                    {ObserveWalletLest.length > 0 && (
                      <div
                        style={{
                          padding: '0 24px',
                          maxHeight: '300px',
                          overflowY: 'auto',
                        }}
                      >
                        <div
                          className="text-14px h-40px leading-40px"
                          style={{ color: 'rgba(173, 177, 184, 1)' }}
                        >
                          {' '}
                          {fm('wallet_observe')}
                        </div>
                        {ObserveWalletLest.map((wallet) => {
                          return (
                            <div
                              className="h-50px"
                              key={wallet.address}
                              style={{
                                cursor: 'pointer',
                                position: 'relative',
                              }}
                              onClick={() => setObserveInfo(wallet)}
                            >
                              <div className="text-16px leading-24px font-500">
                                {wallet.name}
                              </div>
                              <div
                                className="text-14px leading-22px"
                                style={{ color: 'rgba(129, 133, 140, 1)' }}
                              >
                                {shortenAddress(wallet.address || '')}
                              </div>
                              {observeInfo.address &&
                                observeInfo.address === wallet.address && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      right: '16px',
                                      marginTop: '-14px',
                                      top: '50%',
                                    }}
                                  >
                                    {selectIcon()}
                                  </div>
                                )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <div
                      onClick={() => setShowAddWallet(true)}
                      className={styles['dropdown-item']}
                      style={{
                        borderTop: '1px solid rgba(64, 67, 71, 1)',
                        marginTop: '16px',
                      }}
                    >
                      {addIcon()}
                      <div
                        className="ml-10px h-56px"
                        style={{ overflow: 'hidden' }}
                      >
                        {fm('add_observe')}
                      </div>
                    </div>
                    <div
                      onClick={() => router.push(`/${locale}${appPath}/detail`)}
                      className={styles['dropdown-item']}
                    >
                      {settingIcon()}
                      <div className="ml-10px">{fm('wallet_manage')}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* 资产总价值 */}
            <div className="text-48px font-semibold leading-56px mt-16px">
              $ {walletTotalBalance}
            </div>
          </div>
          {/* 图表 */}
          {chartData.length > 0 && (
            <div className={styles.right}>
              <div className="flex flex-row justify-end">
                <div
                  onClick={() => setChartStep(stepMap.week)}
                  className={cls(
                    chartStep === stepMap.week && styles.active,
                    styles.chartTab
                  )}
                >
                  7D
                </div>
                <div
                  onClick={() => setChartStep(stepMap.month)}
                  className={cls(
                    chartStep === stepMap.month && styles.active,
                    styles.chartTab
                  )}
                >
                  30D
                </div>
              </div>
              <div className="w-490px h-116px">
                <SimpleLine
                  xField="dateTime"
                  yField="value"
                  data={chartData}
                  color={'#fff'}
                  padding={5}
                  showYAxis={false}
                  xAxis={false}
                  tooltip={{
                    customContent: (title, data) => {
                      return `<div style="color: rgba(113, 117, 122, 1);font-size;12px;height: 16px; line-height: 16px;">${title}</div> <div style="font-size;12px;color: rgba(113, 117, 122, 1);height: 16px; line-height: 16px;">$${data[0]?.value}</div>`;
                    },
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {/* table */}
        <div className="relative">
          <Tabs
            items={tabList}
            className={styles['balance-tab']}
            activeKey={(router.query?.tab as string) || 'token'}
            onChange={(activeKey) =>
              router.replace({
                pathname: `/${locale}${appPath}`,
                query: { ...router.query, tab: activeKey },
              })
            }
          />
          <div className="absolute right-0 top-0 h-56px flex flex-row justify-center items-center">
            {(router.query.tab === 'token' || !router.query.tab) && (
              <Checkbox
                onChange={onCheckedChange}
                className="text-12px items-center"
              >
                {fm('hidden_assets')}
              </Checkbox>
            )}
            {(router.query.tab === 'token' || !router.query.tab) && (
              <Input
                size="xs"
                className="ml-16px w-240px"
                onChange={onInputChange}
                prefix={<SearchIcon />}
                placeholder={fm('search')}
              />
            )}
            {router.query.tab === 'nft' && (
              <Checkbox
                defaultChecked={hideRiskNft}
                onChange={onHideRiskChange}
                className="text-12px items-center"
              >
                {fm('hideHighRiskNFT')}
              </Checkbox>
            )}

            <Select
              className="ml-16px w-160px"
              notFoundText={fm('no_data')}
              size="xs"
              value={currentChain}
              showAction={['click']}
              showSearch={true}
              onChange={changeHandler}
              width={280}
              virtual={true}
              options={chainListData}
              valueRender={(val: string, item: any) => {
                return (
                  item && (
                    <div
                      key={item.value}
                      className="flex flex-row items-center"
                    >
                      {item.icon}
                      <div className="ml-4px text-12px">{item.label}</div>
                    </div>
                  )
                );
              }}
              RenderNode={(item: any) => {
                return (
                  item && (
                    <div
                      key={item.value}
                      className="flex flex-row items-center min-h-34px"
                    >
                      {item.icon}
                      <div className="ml-4px text-12px">{item.label}</div>
                      {item.value !== 'ALL' && (
                        <div
                          style={{ color: 'rgba(173, 177, 184, 1)' }}
                          className="ml-8px text-10px"
                        >
                          ${item.amountUsd}
                        </div>
                      )}
                    </div>
                  )
                );
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        title={fm('add_address_more')}
        className="w-480px"
        open={showAddWallet}
        onCancel={() => setShowAddWallet(false)}
        footer={
          <>
            <Button
              onClick={addObserveWallet}
              disabled={
                formWalletName?.length > 30 ||
                !formWalletName ||
                !formWalletAddress
              }
              className="w-416px"
              variant="primary"
            >
              {fm('confirm')}
            </Button>
          </>
        }
      >
        <div>
          {/* 钱包名称 */}
          <div>
            <label className="text-base-bds-gray-t2 text-[14px] mb-2  inline-block">
              {fm('walletName')}
            </label>
            <Input
              value={formWalletName}
              onChange={(e) => {
                setFormWalletName(e.target.value);
              }}
              variant={
                (formWalletName !== undefined &&
                  formWalletName?.length > 30 &&
                  'error') ||
                undefined
              }
              size="xs"
              width={416}
            />
            <div
              className={cls(
                'text-redColor-bds-red-700-normal text-[14px] mt-2'
              )}
              style={{
                display:
                  formWalletName !== undefined && formWalletName?.length > 30
                    ? 'block'
                    : 'none',
              }}
            >
              {fm('walletNameSoLong')}
            </div>
          </div>
          {/* 网络 */}
          <div className="mt-24px">
            <label className="text-base-bds-gray-t2 text-[14px] mb-2  inline-block">
              {fm('network')}
            </label>
            <Select
              notFoundText={fm('no_data')}
              size="xs"
              value={formWalletChain}
              showAction={['click']}
              showSearch={true}
              onChange={(val) => setFormWalletChain(val as string)}
              width={416}
              virtual={true}
              options={chainList.map((item) => {
                return { label: item.chainName, value: item.chainCode };
              })}
            ></Select>
          </div>
        </div>
        <div className="mt-24px">
          <label className="text-base-bds-gray-t2 text-[14px] mb-2  inline-block">
            {fm('walletAddress')}
          </label>
          <Textarea
            showCount={false}
            placeholder={fm('wallet_address_placeholder')}
            label=""
            className="w-416px"
            onChange={(e) => setFormWalletAddress(e.target.value)}
          />
        </div>
      </Modal>
      <Web3CopyCloudWalletModal
        visible={showCopyModal}
        onClose={() => setShowCopyModal(false)}
      />
      <Web3DepositModal
        visible={showDepostiModal}
        token={{
          chainCode: depositChain,
          token: depositToken,
          walletAddress: wallet.getAddress(depositChain),
        }}
        onClose={() => {
          setShowDepositModal(false);
        }}
      />
    </div>
  );
};
